import * as React from 'react';

import * as S from './BarProgress.style';
import { IBarProgressProps } from './BarProgress.type';

export const BarProgress: React.FC<IBarProgressProps> = ({
  percentage,
  color,
  animate = false,
  animationDelay = '1s',
  ...rest
}) => (
  <S.BarContainer {...rest}>
    <S.Bar percentage={percentage} color={color} animate={animate} animationDelay={animationDelay} />
  </S.BarContainer>
);

export default BarProgress;
